import { isTouchDevice } from '../common/util'
import { slideDown, slideUp } from '../common/slide'
import { on } from 'delegated-events'
import hoverintent from 'hoverintent'

let scrollStart

const fn = {
  init: () => {
    document.querySelectorAll('.byg-pet-item').forEach((el) => {
      hoverintent(el, fn.handlePetEnter, fn.handlePetExit).options({
        interval: 20,
      })
    })

    if (isTouchDevice()) {
      on('touchstart', '.byg-pet-item', (e) => {
        scrollStart = e.touches[0].clientY
      })
      on('touchend', '.byg-pet-item', fn.handleTouch)
    }
  },

  handleTouch: (e) => {
    const item = e.target.closest('.byg-pet-item')

    const scrollDiff = Math.abs(e.changedTouches[0].clientY - scrollStart)

    if (item && scrollDiff < 10) {
      if (item.classList.contains('is-active') && e.target.closest('.byg-pet-image')) {
        fn.handlePetExit(e)

        return
      }

      if (!item.classList.contains('is-active')) {
        fn.handlePetEnter(e)

        return
      }
    }
  },

  handlePetEnter: (e) => {
    const item = e.target.closest('.byg-pet-item')
    const bio = item.querySelector('.byg-pet-bio')
    const image = item.querySelector('.byg-pet-image')

    if (item.classList.contains('is-active')) {
      return
    }

    const otherItems = document.querySelectorAll('.byg-pet-item.is-active')

    fn.closeOtherPets(otherItems)

    const imageRect = image.getBoundingClientRect()

    item.classList.add('is-active')
    item.classList.add('bio-bottom')
    bio.style.top = `${imageRect.height}px`

    slideDown(bio, 250)
  },

  handlePetExit: (e) => {
    const item = e.target.closest('.byg-pet-item')
    const bio = item.querySelector('.byg-pet-bio')

    if (e.relatedTarget && e.relatedTarget.closest('.byg-pet-item')) {
      return
    }

    slideUp(bio, 250).then(() => {
      item.classList.remove('is-active')
      item.classList.remove('bio-bottom')
      bio.style.bottom = null
      bio.style.top = null
      bio.style.display = null
    })
  },

  closeOtherPets: (others) => {
    others.forEach((el) => {
      fn.handlePetExit({ target: el, relatedTarget: document.documentElement })
    })
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-becauseyougivepage'),
  run: fn.init,
}
